<script lang="ts" setup>
  import ReportDownloadRow from '~/components/reports/downloads/ReportDownloadRow.vue'
  import type { UseReportRunsReturn } from '~/composables/reports/useReportRuns'
  import type { ServiceRun } from '~/types/report-service'

  defineProps<{
    entries: ServiceRun[]
    runs: UseReportRunsReturn
  }>()
</script>

<template>
  <ul class="flex flex-col gap-2">
    <ReportDownloadRow
      v-for="run in entries"
      :key="run.id"
      :can-cancel="runs.canCancel(run)"
      :can-retry="runs.canRetry(run)"
      :downloading-key="runs.downloading.value"
      :run="run"
      @cancel="runs.cancel"
      @download="runs.download"
      @retry="runs.retry"
    />
  </ul>
</template>
